export const status = [
  {
    id: '01',
    name: 'ACTIVE'
  },
  {
    id: '02',
    name: 'INACTIVE'
  }
]

export const yesOrNO = [
  {
    id: '01',
    name: 'YES'
  },
  {
    id: '02',
    name: 'NO'
  }
]
